import Navbar from "layout/navbar/Navbar";
import React, { useEffect, useState } from "react";
import Banner from "./Banner";
import ProjectSearchBar from "shared/ProjectSearchBar";
import { useSelector } from "react-redux";

const DonatePageSections = () => {
  const { projects } = useSelector((state) => state.project);
  const [result, setResult] = useState(projects);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <Navbar />
      <ProjectSearchBar donate setResult={setResult} />
      <Banner donate="donate" result={result} />
    </div>
  );
};

export default DonatePageSections;
